import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";

function initialsOf(name) {
  return (name || "?").trim().split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase() || "?";
}

// Small round avatar. Tries `src`; falls back to initials if there's no photo (onError).
export function Avatar({ src, name, size = 32, className, testId }) {
  const [err, setErr] = useState(false);
  useEffect(() => { setErr(false); }, [src]);
  const style = { width: size, height: size, minWidth: size };
  if (src && !err) {
    return (
      <img src={src} alt={name || ""} onError={() => setErr(true)} style={style}
        className={cn("rounded-full object-cover bg-zinc-100 border border-zinc-200", className)} data-testid={testId} />
    );
  }
  return (
    <div style={style} data-testid={testId}
      className={cn("rounded-full bg-cc-blue/10 text-cc-blue flex items-center justify-center font-semibold shrink-0 border border-cc-blue/15", className)}>
      <span style={{ fontSize: Math.max(10, Math.round(size * 0.4)) }}>{initialsOf(name)}</span>
    </div>
  );
}
